class Table {
    constructor() {
      this.tableBody = document.querySelector('.sht-table_body');

      if(this.tableBody) {
        this.getApi();
        this.headerArr = ['rank', 'domain', 'categories', 'country_code', 'domain_url'];
        this.counter = 0;
      }
    }

    getApi() {
      fetch('https://cdn.shopify.com/s/files/1/0090/9236/6436/files/file_csv1-1.csv?v=1678703946')
      .then((response) => {
        return response.text();
      })
      .then((data) => {
        console.log(data);
        this.handleData(data);
      })
      .catch((error) => console.log(error))
    }

    handleData(data) {
      const allRows = data.split(/\r?\n|\r/);
      console.log(allRows.length);
      allRows[0].split(',').forEach((ele, index) => {

        if (ele == this.headerArr[1]) {
          this.domainIndex = index;
        }
        else if (ele == this.headerArr[2]) {
          this.cateIndex = index;
        }
        else if (ele == this.headerArr[3]) {
          this.countryIndex = index;
        }
        else if (ele == this.headerArr[4]) {
          this.urlIndex = index;
          this.counter++;
        }
      });

      let tableRow = '';
      for (let singleRow = 1; singleRow < allRows.length - 1; singleRow++) {
        let rowCells = allRows[singleRow].split(',');

        this.url = this.counter > 0 ? rowCells[this.urlIndex] : `https://${rowCells[this.domainIndex]}`;
        console.log(this.rankIndex);
        tableRow = tableRow + `
        <div class="sht-table_row">
          <div class="sht-table_col">
            ${singleRow}
          </div>
          <div class="sht-table_col">
            <a href="${this.url}" target="_blank" rel="nofollow noopener noreferrer">${rowCells[this.domainIndex]}</a>
          </div>
          <div class="sht-table_col">
            ${rowCells[this.cateIndex].split('/')[1]}
          </div>
          <div class="sht-table_col">
            ${rowCells[this.countryIndex]}
          </div>
        </div>
        `
      }
      this.tableBody.innerHTML = tableRow;
    }
  }
  const objTable = new Table();